import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import './styles/PartnerOpen.scss'

import { getPartner } from 'panel/partner/redux/actions'

import PartnerCard from './components/PartnerCard'
import PartnerInfo from './components/PartnerInfo'
import PartnerStaff from '../staff/PartnerStaff'
import PartnerDeliveryConfig from '../delivery/PartnerDeliveryConfig'

const PartnerConfig: React.FC = () => {
  const { id } = useParams<{ id: string}>()
  const dispatch = useDispatch()

  useEffect(() => {
    if (id) {
      getPartner(id)(dispatch)
    }
  }, [id, dispatch])

  return (
    <div className="row partner-config">
      <PartnerCard />
      <PartnerInfo />

      <PartnerDeliveryConfig type="PRICE_BY_DISTANCE" label="Configuração de Entregas" />
      <PartnerDeliveryConfig type="FREE_SHIPPING" label="Configuração de Desconto em Entregas" />
      <PartnerStaff />
    </div>
  )
}

export default PartnerConfig
